import { ReactNode } from 'react'
import { Cell, Spacer, Text } from '@vinted/web-ui'

type Props = {
  title: ReactNode
  subtitle: ReactNode
  styling?: React.ComponentProps<typeof Cell>['styling']
}

const Heading = ({ title, subtitle, styling = Cell.Styling.Wide }: Props) => {
  return (
    <Cell styling={styling}>
      <Text as="h1" type={Text.Type.Heading}>
        {title}
      </Text>
      <Spacer size={Spacer.Size.Regular} />
      <Text as="span" html>
        {subtitle}
      </Text>
    </Cell>
  )
}

export default Heading
